import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NotificationTemplateStoreEffects } from './effects';
import { notificationTemplateReducer } from './reducer';
import { NotificationTemplateFacade } from './facade';
import { stateName } from './selectors';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(stateName, notificationTemplateReducer),
    EffectsModule.forFeature([NotificationTemplateStoreEffects]),
  ],
  exports: [],
  providers: [NotificationTemplateFacade],
  declarations: [],
})
export class NotificationTemplateStateModule {}
